import _ from "lodash";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryLicensePlate from 'graphql/queries/QueryLicensePlate'
import GraphqlBuilder from 'utils/request/graphql/builder'

const FetchLicensePlate = {
	
	prepareValue: ( value ) => {
		if( !_.isString( value ) ) {
			return '';
		}
		
		return _.toUpper( _.replace( _.trim( value ), /-|\s/g, '' ) );
	},

	fetch: ( value, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'license_plate', QueryLicensePlate, {
			variables: {
				license_plate: value
			},
			resultPath: [ 'license_plate' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( result );
				}
			},
		})
	},
	
	fetchAll: ( values, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const builder = new GraphqlBuilder();
		
		_.forEach( values, (value, key) => {
			builder.addQuery( `license_plate_${ key }`, QueryLicensePlate, {
				license_plate: value.license_plate,
				timeslot_guid: value.timeslot_guid ?? null
			})
		});
		
		builder.setOnSuccess( results => {
			const licensePlates = _.map( results, (result, key) => {
				return {
					...result.license_plate,
					original_license_plate: values[ _.replace( key, 'license_plate_', '' ) ].license_plate,
				};
			})
			
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( licensePlates );
			}
		})
		
		builder.setOnError( error => {
			if( _.isFunction( callbackError ) ) {
				callbackError( error );
			}
		})
		
		builder.execute();
	},
}

export default FetchLicensePlate
